const copyTextToClipboard = button => {
    const textId = button.getAttribute('aria-describedby');
    const text = document.getElementById(textId).textContent;
    
    navigator.clipboard.writeText(text).then(() => {
        button.classList.add('btn-outline-success');
    });
};

document.querySelectorAll('.copy-prompt').forEach(button => {
    button.addEventListener('click', () => {
        copyTextToClipboard(button);
    });
});
